import common from './common';
import problems from './problems';
import home from './home';
import incidents from './incidents';
import saas from './saas';

export default [...common, ...home, ...problems, ...saas, ...incidents];
